import { useQuery } from '@tanstack/react-query'
import { queryKeys } from 'commons/hooks/services/queryKeys'
import { lydiaPageService } from 'commons/services/lydiaPageService'

const useLydiaPage = (pageTag: string) => {
	return useQuery({
		queryKey: queryKeys.lydiaPage.getLydiaPageInfo(pageTag),
		queryFn: () => lydiaPageService.getLydiaPageInfo(pageTag)
	})
}

export default useLydiaPage
